import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMessage } from "../../redux";
import Input from "../../components/Input";
import CheckList from "../../components/CheckList";
import "./style.css"

const el = [
    {
        h2: `1 — Identité du professionnel`,
        sub: `Merci de renseigner vos informations professionnelles générales`,
        sub2: `Ces données constitueront votre fiche dans l’annuaire PSOA.`
    },
    {
        h2: `2 — Outils de communication privilégiés`,
        sub: `Choisissez les outils et canaux que vous utilisez pour différents types d’échanges : patient, administratif, avis/conseils, réunions.`,
    },
    {
        h2: `3 — Modalités de contact selon le degré d’urgence`,
        sub: `Indiquez comment vous préférez être contacté en fonction du délai de réponse attendu (<2h, <24h, <1 semaine).`,
    },
    {
        h2: `4 — Informations attendues de la part des autres professionnels`,
        sub: `Renseignez ce que vous attendez des autres professionnels lors de communications interprofessionnelles. Renseignez uniquement les attentes qui concernent votre profession par exemple : je suis médecin dans la partie "Informations attendues du Kinésithérapeute" je veux que les Kinésithérapeutes m'envoient leur demande de renouvellement d'ordonnance via mon adresse mail sécurisée MSsanté.`,
    },
    {
        h2: `5 — Mes publics de prédilection`,
        sub: `Indiquez les types de publics avec lesquels vous travaillez le plus souvent. Sélectionnez toutes les options pertinentes.`,
    },
];

function Profil() {
    const dispatch = useDispatch();
    const profilState = useSelector(state => state.profil);

    const [page, setPage] = useState(1);
    const [msgAlert, setAlert] = useState(false);

    const [form, setForm] = useState({
        firstName: '',
        lastName: '',

        profession: '',
        otherProfession: '',

        mainLocation: '',
        secondaryLocations: '',

        proPhone: '',
        secretaryPhone: '',

        proEmail: '',
        secureProEmail: '',

        patientComTool: [],
        otherPatientComTool: '',

        adminComTool: [],
        otherAdminComTool: '',

        interproTool: [],
        otherInterproTool: '',

        meetingTool: [],
        otherMeetingTool: '',

        urgentContact: [],
        otherUrgentContact: '',

        dailyContact: [],
        otherDailyContact: '',

        weeklyContact: [],
        otherWeeklyContact: '',

        targetAudiences: [],
        otherTargetAudiences: '',

        importantInfo: '',

        infoExpected: {
            physiotherapist: '',
            pharmacist: '',
            ide: '',
            others: [],
        },
    });
    const [alertCss, setAlertCss] = useState({
        lastName: false,
        firstName: false,
        profession: false,
        otherProfession: false,
        mainLocation: false,
        secondaryLocations: false,
        proPhone: false,
        secretaryPhone: false,
        proEmail: false,
        secureProEmail: false,

        patientComTool: false,
        adminComTool: false,
        interproTool: false,
        meetingTool: false,
        urgentContact: false,
        dailyContact: false,
        weeklyContact: false,
        targetAudiences: false,

        alert: false
    })

    useEffect(() => {
        if (profilState) setForm({ ...form, ...profilState });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profilState])

    const next = () => {
        setAlert(false);
        let newAlert = {};
        let hasError = false;

        switch (page) {
            case 1:
                newAlert = {
                    ...alertCss,
                    lastName: form.lastName === '',
                    firstName: form.firstName === '',
                    profession: form.profession === '',
                    otherProfession: form.profession === 'AUTRE' && form.otherProfession === '',
                    mainLocation: form.mainLocation === '',
                    secondaryLocations: form.secondaryLocations === '',
                    proPhone: form.proPhone === '',
                    secretaryPhone: form.secretaryPhone === '',
                    proEmail: form.proEmail === '',
                    secureProEmail: form.secureProEmail === ''
                };
                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return
                break;

            case 2:
                newAlert = {
                    ...alertCss,
                    patientComTool: form.patientComTool.length === 0 || (form.patientComTool.length === 1 && form.patientComTool.includes('AUTRE') && form.otherPatientComTool === ''),
                    adminComTool: form.adminComTool.length === 0 || (form.adminComTool.length === 1 && form.adminComTool.includes('AUTRE') && form.otherAdminComTool === ''),
                    interproTool: form.interproTool.length === 0 || (form.interproTool.length === 1 && form.interproTool.includes('AUTRE') && form.otherInterproTool === ''),
                    meetingTool: form.meetingTool.length === 0 || (form.meetingTool.length === 1 && form.meetingTool.includes('AUTRE') && form.otherMeetingTool === ''),
                };

                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return
                break;

            case 3:
                newAlert = {
                    ...alertCss,
                    urgentContact: form.urgentContact.length === 0 || (form.urgentContact.length === 1 && form.urgentContact.includes('AUTRE') && form.otherUrgentContact === ''),
                    dailyContact: form.dailyContact.length === 0 || (form.dailyContact.length === 1 && form.dailyContact.includes('AUTRE') && form.otherDailyContact === ''),
                    weeklyContact: form.weeklyContact.length === 0 || (form.weeklyContact.length === 1 && form.weeklyContact.includes('AUTRE') && form.otherWeeklyContact === ''),
                };

                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return
                break;

            case 4:
                break;

            default:
                return
        }
        setPage(page + 1)
    }

    const updateProfil = async (e) => {
        e.preventDefault();
        const newAlert = {
            ...alertCss,
            targetAudiences: form.targetAudiences.length === 0 || (form.targetAudiences.length === 1 && form.targetAudiences.includes('AUTRE') && form.otherTargetAudiences === ''),
        };
        setAlertCss(newAlert);

        const hasError = Object.values(newAlert).some(v => v === true);
        if (hasError) return

        const body = {
            lastName: form.lastName,
            firstName: form.firstName,
            profession: form.profession === 'AUTRE' ? form.otherProfession : form.profession,
            mainLocation: form.mainLocation,
            secondaryLocations: form.secondaryLocations,
            proPhone: form.proPhone,
            secretaryPhone: form.secretaryPhone,
            proEmail: form.proEmail,
            secureProEmail: form.secureProEmail,

            patientComTool: form.patientComTool,
            otherPatientComTool: form.otherPatientComTool,
            adminComTool: form.adminComTool,
            otherAdminComTool: form.otherAdminComTool,
            interproTool: form.interproTool,
            otherInterproTool: form.otherInterproTool,
            meetingTool: form.meetingTool,
            otherMeetingTool: form.otherMeetingTool,

            urgentContact: form.urgentContact,
            otherUrgentContact: form.otherUrgentContact,
            dailyContact: form.dailyContact,
            otherDailyContact: form.otherDailyContact,
            weeklyContact: form.weeklyContact,
            otherWeeklyContact: form.otherWeeklyContact,

            targetAudiences: form.targetAudiences,
            otherTargetAudiences: form.otherTargetAudiences,
            importantInfo: form.importantInfo,

            infoExpected: {
                physiotherapist: form.infoExpected.physiotherapist,
                pharmacist: form.infoExpected.pharmacist,
                ide: form.infoExpected.ide,
                others: form.infoExpected.others,
            },
        }

        dispatch(setMessage('Chargement en cour, merci de patienter'));

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/update/${profilState._id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify(body)
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            alert(res.message)
            return
        }
        window.location.reload();
    }

    return (
        <div className="page_profil">
            <form className="form_profil" onSubmit={updateProfil}>
                <h1>Fiche Profil Annuaire PSOA</h1>

                <p className="text">Lorsque vous soumettez ce formulaire, il ne collecte pas automatiquement vos détails, tels que le nom et l’adresse e-mail, sauf si vous le fournissez vous-même.</p>

                <p className="text"><span className="red">*</span> Obligatoire</p>

                <div className="head">
                    <h2>{el[page - 1].h2}</h2>

                    <p className="text">
                        {el[page - 1].sub}
                        {el[page - 1].sub2 ? <br /> : ''}
                        {el[page - 1].sub2 ? el[page - 1].sub2 : ''}
                    </p>
                </div>

                {page === 1 &&
                    <div className="fields">
                        <Input
                            label='Nom' field='lastName'
                            form={form} setForm={setForm}
                            alertCss={alertCss}
                        />
                        <Input
                            label='Prénom' field='firstName'
                            form={form} setForm={setForm}
                            alertCss={alertCss}
                        />

                        <CheckList
                            label='Profession' field='profession' otherField='otherProfession'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={false} type={0}
                        />

                        <Input
                            label='Lieu d’exercice' field='mainLocation'
                            form={form} setForm={setForm}
                            ex='Ex : Champtoceaux, Liré, Bouzillé…' alertCss={alertCss}
                        />
                        <Input
                            label='Adresse professionnelle' field='secondaryLocations'
                            form={form} setForm={setForm}
                            ex="si plusieurs lieux d'exercice vous pourrez le préciser dans la partie notes." alertCss={alertCss}
                        />

                        <Input
                            label='Téléphone direct' field='proPhone'
                            form={form} setForm={setForm}
                            alertCss={alertCss}
                        />
                        <Input
                            label='Téléphone secrétariat' field='secretaryPhone'
                            form={form} setForm={setForm}
                            alertCss={alertCss}
                        />

                        <Input
                            label='Email professionnel (visible pour les professionnels)' field='proEmail'
                            form={form} setForm={setForm}
                            ex="Email avec lequel vous voulez qu'un professionnel de santé vous contacte, sans donnés sensibles (organisation de réunion, demande administratives, etc..)" alertCss={alertCss}
                        />
                        <Input
                            label='Email professionnel sécurisé' field='secureProEmail'
                            form={form} setForm={setForm}
                            ex="Email avec lequel vous voulez qu'un professionnel de santé vous contacte, avec donnés sensibles (échange sur un patient commun, envoi de CR patient)." alertCss={alertCss}
                        />
                    </div>
                }

                {page === 2 &&
                    <div className="fields">
                        <CheckList
                            label='Quel outil préférez vous utiliser pour communiquer au sujet d’un patient ?'
                            field='patientComTool' otherField='otherPatientComTool'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />

                        <CheckList
                            label='Quel outil privilégiez vous pour les échanges administratifs ?'
                            field='adminComTool' otherField='otherAdminComTool'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />

                        <CheckList
                            label='Quel outil préférez vous pour un avis ou un conseil interprofessionnel ?'
                            field='interproTool' otherField='otherInterproTool'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />

                        <CheckList
                            label='Quel outil souhaitez-vous utiliser pour organiser une réunion ?'
                            field='meetingTool' otherField='otherMeetingTool'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />
                    </div>
                }

                {page === 3 &&
                    <div className="fields">
                        <CheckList
                            label='En cas d’urgence (< 2 heures), comment souhaitez vous être contacté ?'
                            field='urgentContact' otherField='otherUrgentContact'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />

                        <CheckList
                            label='Pour une réponse sous 24 heures, comment préférez vous être contacté ?'
                            field='dailyContact' otherField='otherDailyContact'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />

                        <CheckList
                            label='Pour un délai d’environ une semaine, quel canal préférez vous ?'
                            field='weeklyContact' otherField='otherWeeklyContact'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />
                    </div>
                }

                {page === 4 &&
                    <div className="fields">
                        <div className="inp_field">
                            <label>Informations attendues du médecin</label>

                            <textarea
                                placeholder="Entrez votre réponse"
                                onChange={(e) => setForm({ ...form, infoExpected: { ...form.infoExpected, physiotherapist: e.target.value } })}
                                value={form.infoExpected.physiotherapist}
                            ></textarea>
                        </div>

                        <div className="inp_field">
                            <label>Informations attendues du pharmacien</label>

                            <textarea
                                placeholder="Entrez votre réponse"
                                onChange={(e) => setForm({ ...form, infoExpected: { ...form.infoExpected, pharmacist: e.target.value } })}
                                value={form.infoExpected.pharmacist}
                            ></textarea>
                        </div>

                        <div className="inp_field">
                            <label>Informations attendues de l’Infirmier / IDE</label>

                            <textarea
                                placeholder="Entrez votre réponse"
                                onChange={(e) => setForm({ ...form, infoExpected: { ...form.infoExpected, ide: e.target.value } })}
                                value={form.infoExpected.ide}
                            ></textarea>
                        </div>

                        {form.infoExpected.others.length !== 0 &&
                            form.infoExpected.others.map((inf, idx) => (
                                <div className="inp_field" key={idx}>
                                    <label>
                                        Informations attendues
                                        <input
                                            type="text"
                                            value={inf.label}
                                            placeholder='de l’Infirmier / IDE'
                                            onChange={(e) => {
                                                const updatedOthers = [...form.infoExpected.others];
                                                updatedOthers[idx] = {
                                                    ...updatedOthers[idx],
                                                    label: e.target.value
                                                };

                                                setForm({
                                                    ...form,
                                                    infoExpected: {
                                                        ...form.infoExpected,
                                                        others: updatedOthers
                                                    }
                                                });
                                            }}
                                        />
                                    </label>



                                    <textarea
                                        placeholder="Entrez votre réponse"
                                        value={inf.value}
                                        onChange={(e) => {
                                            const updatedOthers = [...form.infoExpected.others];
                                            updatedOthers[idx] = {
                                                ...updatedOthers[idx],
                                                value: e.target.value
                                            };

                                            setForm({
                                                ...form,
                                                infoExpected: {
                                                    ...form.infoExpected,
                                                    others: updatedOthers
                                                }
                                            });
                                        }}
                                    ></textarea>
                                </div>
                            ))
                        }

                        <button
                            type="button"
                            className="btn_add_other_info"
                            onClick={() => {
                                const updatedOthers = [
                                    ...form.infoExpected.others,
                                    { label: '', value: '' }
                                ];

                                setForm({
                                    ...form,
                                    infoExpected: {
                                        ...form.infoExpected,
                                        others: updatedOthers
                                    }
                                });
                            }}
                        >Profession supplémentaire ?</button>
                    </div>
                }

                {page === 5 &&
                    <div className="fields">
                        <CheckList
                            label='Pour quels publics travaillez vous le plus souvent ?'
                            field='targetAudiences' otherField='otherTargetAudiences'
                            form={form} setForm={setForm} alertCss={alertCss}
                            multy={true} type={page - 1}
                        />

                        <div className="inp_field">
                            <label>Autre information important à mentionner ?</label>

                            <textarea
                                placeholder="Entrez votre réponse"
                                onChange={(e) => setForm({ ...form, importantInfo: e.target.value })}
                                value={form.importantInfo}
                            ></textarea>
                        </div>
                    </div>
                }

                <div className="panel">
                    <button type="button" className="btn_prev" onClick={() => setPage(page - 1)} disabled={page === 1}>Précedent</button>
                    {page !== 5 && <button type="button" className="btn_next" onClick={() => next()}>Suivant</button>}
                    {page === 5 && <button className="btn_submit">Mettre à jour</button>}
                </div>

                {msgAlert && <p className="alertMsg">Un ou plussieurs champs sont manquant, merci de renseigner toutes les informations requise.</p>}
            </form>
        </div>
    )
}

export default Profil;